import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { backendBookartUrl } from "../library/constants";
import axios from "axios";

const CreatePassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState(location.state?.email || "");
  const [linkSent, setLinkSent] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

   const sendLink = (event) => {
    event.preventDefault();
    console.log("email:"+email);

    const data = JSON.stringify({
        email: email
      })

    var config = {
        method: "post",
        url: `${backendBookartUrl}/forgot`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      axios(config)
        .then((response) => {
        setLinkSent(true);
        setErrorMessage("");
      })
      .catch((error) => {
        setLinkSent(false);
        setErrorMessage(error.response.data.errormessage);
      });
  };

  return (
    <React.Fragment>
      <Header />
      <section className="body">
        <div className="container">
          <div className="card-content">
            <div className="es-card">
              {!linkSent ? (
                <div className="es-card-body">
                  <img
                    alt="Elsevier"
                    className="elsevier-logo"
                    src="ElsevierStyleSheet/images/elsevier-wordmark.svg"
                  />
                  <h3 className="es-card-title">Password got Expired?</h3>
                  <p className="es-card-text">
                    Get a Link to reset your password.
                  </p>
                  <br /> <br />
                  <form>
                  <div className="es-input-text">
                      <input
                        id="email"
                        name="email"
                        value={email}
                        placeholder="&nbsp;"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <label htmlFor="email">Email</label>
                    </div>
                    </form>
                    <br /> <br />
                  <button
                    className="es-button primary w-100"
                    onClick={sendLink}
                  >
                    <span>Send me a link</span>
                  </button>
                  <br /> <br />
                  <button
                    className="es-button secondary w-100"
                    onClick={(event) => {
                      event.preventDefault();
                      navigate("/");
                    }}
                  >
                    <span>Go back to the sign in</span>
                  </button>
                  <br /> <br />
                  {errorMessage !== "" ? (
                    <div className="formGroup">
                      <div className="error-message">{errorMessage}</div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              ) : (
                <div className="es-card-body">
                  <img
                    alt="Elsevier"
                    className="elsevier-logo"
                    src="ElsevierStyleSheet/images/elsevier-wordmark.svg"
                  />
                  <h4 className="es-card-title-2">
                    An email is on its way to <br />
                    {email}
                  </h4>
                  <p className="font-16">
                    Didn't receive an email? Check your spam folder or{" "}
                    <button
                      className="es-link colored"
                      onClick={(event) => {
                        event.preventDefault();
                        setLinkSent(false);
                      }}
                    >
                      try again
                    </button>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </React.Fragment>
  );
};

export default CreatePassword;